import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'components/shared/select';
import * as selectors from 'selectors/pathBuilder';
import { Icon } from 'ui';
import { routes } from 'constants/config';
import * as actions from 'actions/pathBuilder';
import request from 'utils/request_ajax.js';
import Section, { SectionHeader } from './Section';
import SaveButton from './partials/SaveButton';

class Workspace extends Component {
  state = {
    selectedWorkspace: this.props.workspace,
    loading: false,
  };

  handleSubmit = e => {
    const { id, toggleEditing, updatePath } = this.props;
    const { selectedWorkspace: workspace } = this.state;
    if (!id) {
      updatePath({ workspace });
      toggleEditing();
    } else {
      this.setState({ loading: true }, () => {
        request
          .put(routes.PATH(id), { workspace_id: workspace.id })
          .then(response => {
            updatePath({ workspace: response.workspace });
            this.setState({ loading: false }, toggleEditing);
          });
      });
    }
  };

  handleSelectChange = ({ target: { value, options, selectedIndex } }) => {
    this.setState({
      selectedWorkspace: {
        id: value,
        name: options[selectedIndex].dataset.name,
      },
    });
  };

  render() {
    const { loading } = this.state;
    const { workspaces, editing, isArchived, workspace, toggleEditing } =
      this.props;
    return (
      <Section>
        <SectionHeader className="d-f jc-sb">
          {t('workspaces.workspace')}
          {!isArchived && !editing && (
            <button
              type="button"
              className="u-linkBtn fz-base fw-n"
              onClick={toggleEditing}
            >
              <Icon name="edit" className="mr-4" /> {t('common.edit')}
            </button>
          )}
        </SectionHeader>
        {!editing && (
          <div className="c-brand-gray-darker">{workspace.name}</div>
        )}
        {editing && (
          <div>
            <Select
              fullWidth
              defaultValue={workspace.id || ''}
              onChange={this.handleSelectChange}
            >
              {workspaces.map(({ id, name }) => (
                <option key={id || 'default'} value={id || ''} data-name={name}>
                  {name}
                </option>
              ))}
            </Select>
            <div className="d-f jc-e ai-c mt-8">
              <button
                type="button"
                className="u-linkBtn u-linkBtn--dark td-u"
                onClick={toggleEditing}
                disabled={loading}
              >
                {t('common.cancel')}
              </button>
              <SaveButton loading={loading} onClick={this.handleSubmit} />
            </div>
          </div>
        )}
      </Section>
    );
  }
}

const UI_STATE_KEY = 'workspace';

const mapStateToProps = ({ pathBuilder, meta }) => ({
  id: pathBuilder.id,
  editing: selectors.isEditingUIElementByName(pathBuilder, UI_STATE_KEY),
  isArchived: selectors.isArchived(pathBuilder),
  workspace: pathBuilder.workspace,
  workspaces: meta.workspaces,
});

const mapDispatchToProps = {
  updatePath: actions.updatePath,
  toggleEditing: actions.toggleEditingUIElementByName.bind(null, UI_STATE_KEY),
};

export default connect(mapStateToProps, mapDispatchToProps)(Workspace);
